export default {
  setMigrationDialogHeader: 'Start der Migration festlegen',
  setMessage: 'Der Migrationsstatus von {count} {type} wird zurückgesetzt, und alle {type} werden erneut ab {date} migriert.',
  setMigrationDialogErrorPast: 'Der gewählte Zeitpunt muss in der Vergangenheit liegen.',
};
